import { render, staticRenderFns } from "./head.vue?vue&type=template&id=74964622"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports